"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const configsBase_1 = require("../configsBase");
const store_1 = require("../../store");
class Config extends configsBase_1.ConfigCommon {
    constructor() {
        super(...arguments);
        this.getSessionStoreConfig = () => ({
            store: (0, store_1.getDefaultSessionStore)(),
        });
        this.bankId = 'OK_MX';
        this.language = 'es-MX';
    }
}
exports.Config = Config;
//# sourceMappingURL=config.js.map